import angular from 'angular';
import { downgradeComponent } from '@angular/upgrade/static';
import { LabelWrapperComponent } from './label-wrapper.component';

export { LabelWrapperModule } from './label-wrapper.module';
export const ngxLabelWrapperModule = angular.module('ngxLabelWrapperModule', [])
	.directive('ngxLabelWrapper', downgradeComponent({component: LabelWrapperComponent}))
	.name;
